import module from 'fan/proyecto/module.js'
import * as moment from 'moment'

export const schema = {
  idse_id: 'number',
  id_tipo_movimiento: 'number',
  movimientos: 'number',
  fecha: 'date',
}

export class FanProyectoColaboradoresIDSEHistorialService {
  constructor ($http) {
    this.$http = $http
  }

  get (proyectoId, fechaInicial, fechaFinal) {
    return this.$http.get(`/api2/proyecto/colaboradores/idse/historial`, {
      params: {
        proyecto_id: proyectoId,
        fecha_inicial: moment(fechaInicial).format('YYYY-MM-DD'),
        fecha_final: moment(fechaFinal).format('YYYY-MM-DD'),
      },
      schema,
    })
  }
}

module.service('FanProyectoColaboradoresIDSEHistorialService', FanProyectoColaboradoresIDSEHistorialService)



// WEBPACK FOOTER //
// ./src/fan/proyecto/services/Proyecto/Colaboradores/IDSE/Historial.js